import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
const typeOfSampleDrawingOptions = [
  { value: "", label: "Select an option" },
  { value: "SO-OL", label: "SO-OL" },
  { value: "N", label: "N" },
  { value: "C", label: "C" },
  { value: "S", label: "S" },
  { value: "SO", label: "SO" },
  { value: "F", label: "F" },
  { value: "FO", label: "FO" },
  { value: "S-E", label: "S-E" },
  { value: "SO-E", label: "SO-E" },
  { value: "S-OL", label: "S-OL" },
];
const sampleDrwaingMethodOptions = [
  { value: "PO", label: "PO" },
  { value: "SKU", label: "SKU" },
];

const PopupComponent = ({ onClose, onSave, initialValues }) => {
  const [sampleQuantityValue, setSampleQuantityValue] = useState("");
  const [numberAndRecipientValue, setTxtNumberAndRecipientValue] = useState("");
  const [typeOfSampleDrawingValue, setTypeOfSampleDrawingValue] = useState("");
  const [sampleDrwaingMethodValue, setSampleDrwaingMethodValue] = useState("");
  const [sampleQuantityError, setSampleQuantityError] = useState(false);
  const [typeOfSampleDrawingError, setTypeOfSampleDrawingError] =
    useState(false);

  function splitLastOccurrence(str, substring) {
    const arr = str.split(substring);

    const after = arr.pop();

    const before = arr.join(substring);

    return [before, after];
  }
  useEffect(() => {
    // Set initial values when the component is mounted
    if (initialValues) {
      const SampingAndPackagingCode = initialValues.split("/");
      const [before, after] = splitLastOccurrence(
        SampingAndPackagingCode[0].split("#")[1],
        "-"
      );

      setSampleQuantityValue(after || "");
      setTxtNumberAndRecipientValue(SampingAndPackagingCode[2] || "");
      setTypeOfSampleDrawingValue(before || "");
      setSampleDrwaingMethodValue(SampingAndPackagingCode[1] || "");
    }
  }, [initialValues]);
  const handleSampleQuantityChange = (e) => {
    const inputValue = e.target.value;
    // Only update the state if the input matches the pattern (2 digits)
    if (/^\d{0,2}$/.test(inputValue)) {
      setSampleQuantityValue(inputValue);
    }
  };

  const handleSave = () => {
    if (typeOfSampleDrawingValue === "") {
      setTypeOfSampleDrawingError(true);
      return;
    }
    if (sampleQuantityValue.trim() === "") {
      setSampleQuantityError(true);
      return;
    }
    let values = `S#`;
    if (typeOfSampleDrawingValue) {
      values = values + `${typeOfSampleDrawingValue}`;
    }
    if (sampleQuantityValue) {
      values = values + `-${sampleQuantityValue}`;
    }
    if (sampleDrwaingMethodValue) {
      values = values + `/${sampleDrwaingMethodValue}`;
    }
    if (numberAndRecipientValue) {
      values = values + `/${numberAndRecipientValue}`;
    }

    onSave(values);
    onClose();
  };

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>Sampling and Packaging Code</DialogTitle>
      <DialogContent>
        <FormControl
          variant="standard"
          fullWidth
          error={typeOfSampleDrawingError}
          style={{
            fontSize: "12px",
          }}
        >
          <InputLabel
            id="demo-simple-select-label"
            style={{
              fontSize: "12px",
            }}
          >
            Type of sample drawing
          </InputLabel>
          <Select
            style={{
              fontSize: "12px",
            }}
            variant="standard"
            labelId="demo-simple-select-label"
            value={typeOfSampleDrawingValue}
            onChange={(e) => {
              setTypeOfSampleDrawingValue(e.target.value);
              setTypeOfSampleDrawingError(false);
            }}
          >
            <MenuItem
              value=""
              style={{
                fontSize: "12px",
              }}
            ></MenuItem>
            {typeOfSampleDrawingOptions.map((option) => (
              <MenuItem
                style={{
                  fontSize: "12px",
                }}
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {typeOfSampleDrawingError && (
            <span style={{ color: "red", fontSize: 12 }}>
              This field is required.
            </span>
          )}
        </FormControl>
        <TextField
          style={{
            fontSize: "12px",
          }}
          variant="standard"
          id="txtSampleQuantity"
          label="Sample Quantity"
          value={sampleQuantityValue}
          onChange={handleSampleQuantityChange}
          fullWidth
          error={sampleQuantityError}
          helperText={sampleQuantityError ? "This field is required." : ""}
        />

        <FormControl fullWidth variant="standard">
          <InputLabel
            id="sampleDrawing"
            style={{
              fontSize: "12px",
            }}
          >
            Sample drawing method{" "}
          </InputLabel>
          <Select
            labelId="sampleDrawing"
            variant="standard"
            style={{
              fontSize: "12px",
            }}
            value={sampleDrwaingMethodValue}
            onChange={(e) => setSampleDrwaingMethodValue(e.target.value)}
          >
            <MenuItem
              value=""
              style={{
                fontSize: "12px",
              }}
            >
              Select an option
            </MenuItem>
            {sampleDrwaingMethodOptions.map((option) => (
              <MenuItem
                style={{
                  fontSize: "12px",
                }}
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          style={{
            fontSize: "12px",
          }}
          variant="standard"
          label="Number and recipient"
          value={numberAndRecipientValue}
          onChange={(e) => setTxtNumberAndRecipientValue(e.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PopupComponent;
